export const ADD_USER = "ADD_USER";
export const LOGOUT = "LOGOUT";
export const CHANGE_SELECTED_SMVP = "CHANGE_SELECTED_SMVP";
